module.exports = "/static/media/exams.6d25d374.svg";